:host {
  $wc-ticket-notification-color: var(--orange, #ff8500);

  .overflow--hidden {
    overflow: hidden;
    height: 100%;
    .layout {
      position: relative;
      width: 100%;
      height: 75vh;

      @media screen and (max-width: 576px) {
        height: 100%;
      }

      bottom: 0;
      right: 0;
      z-index: 1000;
      box-sizing: border-box;
      &.is-logged {
        height: calc(100% - 70px);
        .landing {
          border-radius: 0 0 8px 8px;
        }
      }
    }
  }
  .hide {
    display: none !important;
  }

  .blue-link {
    color: #0098ff;
    background: transparent;
    border: none;

    &.see-help {
      font-size: 16px;
      padding: 0;
    }

    &:hover {
      color: #0073c0;
    }
  }

  .right {
    cursor: pointer;
    @media screen and (min-width: 768px) {
      margin-left: auto;
    }
  }

  .check {
    width: 20px;
  }

  .header-full-container__title {
    font-size: 30px;
    text-align: center;
    padding-bottom: 30px;
    padding-top: 30px;
  }

  .landing {
    width: 100%;
    height: 100%;
    color: #fff;
    border-radius: 8px;
    padding: 30px 20px;
    box-sizing: border-box;
    overflow: auto;

    background: linear-gradient(180deg, #2d6ae0 0%, #1d50d5 100%), #f4f6fd;
    &.background-pro {
      background: linear-gradient(180deg, #2d6ae0 -381.46%, #0c3191 100%), #ffffff;
    }
    &.background-business {
      background: linear-gradient(180deg, #2d6ae0 -381.46%, #3a3652 100%), #ffffff;
    }

    &.full {
      width: 600px;
      background: transparent;
      margin: auto;
      overflow-x: hidden;
      height: auto;
    }

    &__title-account {
      width: fit-content;
      padding: 8px;
      border-radius: 4px;
      background: rgba(0, 0, 0, 0.2);
      margin-bottom: 16px;
      font-size: 14px;
      font-weight: 400;
      span {
        font-size: 14px;
        font-weight: 500;
      }
    }

    &__title {
      margin-bottom: 8px;
      font-size: 32px;
    }

    &__subtitle {
      font-size: 14px;
      .current-premium-support {
        strong {
          font-weight: 500;
        }
        span {
          cursor: pointer;
          text-decoration: underline;
        }
      }
    }

    &__card {
      width: 100%;
      background: #fff;
      padding: 20px 40px;
      box-sizing: border-box;
      border-radius: 8px;
      margin-top: 16px;

      &.flex-row {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
      }

      &.clickable {
        transition: background ease 0.2s;

        &:hover {
          cursor: pointer;
          background: #f5f5f5;
        }
      }

      &.disabled {
        opacity: 0.8;
        &:hover {
          cursor: not-allowed;
          background: #fff;
        }
      }

      &--header {
        display: flex;
        flex-direction: row;
        gap: 16px;
        justify-content: flex-start;
        align-items: center;

        &-icon {
          width: 42px;
          height: 42px;
        }
      }

      &--title {
        display: flex;
        align-items: center;
        gap: 8px;
        color: #333;
        font-size: 22px;
        font-weight: 500;
        line-height: 24px;

        .notification-dot {
          background: $wc-ticket-notification-color;
          width: 8px;
          height: 8px;
          display: block;
          border-radius: 50%;
        }
      }

      &--description {
        font-size: 16px;
        line-height: 24px;
        padding-left: 58px;
        width: 75%;
        color: #666;

        .accent {
          font-size: 18px;
          font-weight: 500;
          color: #0098ff;
        }
      }
    }

    .support-access {
      &__header {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        gap: 16px;
        margin-bottom: 16px;
      }

      &__line {
        display: flex;
        align-items: center;
        gap: 24px;
        font-size: 14px;
        font-weight: 400;
        color: #666;
        margin-bottom: 24px;
        &.first-line {
          margin-bottom: 16px;
        }
        .code {
          display: flex;
          align-items: center;
          gap: 8px;
          padding: 1px 8px;
          border-radius: 8px;
          font-weight: 500;
          background-color: #f5f5f5;
          color: #333;
        }
      }

      .kmeet-button {
        display: flex;
        align-items: center;
        gap: 8px;
        padding: 6px 16px 6px 8px;
        border: 0;
        border-radius: 4px;
        font-size: 14px;
        font-weight: 400;
        background-color: #3dbd86;
        color: #fff;

        .bg-icon {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 33px;
          height: 33px;
          border-radius: 4px;
          background-color: #fff;
        }
      }

      .switch {
        input[type='checkbox'] {
          height: 0;
          width: 0;
          visibility: hidden;
          position: absolute;
        }

        label {
          cursor: pointer;
          text-indent: -9999px;
          width: 36px;
          height: 20px;
          background: #e0e0e0;
          background: var(--divider);
          display: block;
          border-radius: 24px;
          position: relative;
        }

        label:after {
          content: '';
          position: absolute;
          top: 2px;
          left: 2px;
          width: 16px;
          height: 16px;
          background: #fff;
          border-radius: 10px;
          transition: 0.3s;
        }

        input:checked + label {
          background: #0098ff;
          background: var(--blue);
        }

        input:checked + label:after {
          left: calc(100% - 2px);
          transform: translateX(-100%);
        }

        label:active:after {
          width: 30px;
        }
      }

      .tooltip {
        position: relative;
        display: flex;
        margin-left: auto;
      }

      .tooltip .tooltiptext {
        visibility: hidden;
        width: 180px;
        background-color: #333;
        background-color: var(--bg-tooltip);
        color: #f5f5f5;
        color: var(--font-tooltip);
        text-align: center;
        border-radius: 6px;
        padding: 5px 0;
        position: absolute;
        z-index: 1;
        bottom: 125%;
        opacity: 0;
        transition: opacity 0.3s;
        padding: 10px;
        box-shadow: 0 0 10px 0 rgba(51, 51, 51, 0.15);
        margin-left: 0;
        right: -6px;
        font-size: 14px;
        letter-spacing: 0;
        line-height: 21px;
      }

      .tooltip .tooltiptext::after {
        content: '';
        position: absolute;
        top: 100%;
        right: 10px;
        margin-left: -5px;
        border-width: 5px;
        border-style: solid;
        border-color: #fff transparent transparent transparent;
        border-color: var(--bg-tooltip) transparent transparent transparent;
      }

      .tooltip:hover .tooltiptext {
        visibility: visible;
        opacity: 1;
      }
    }
  }

  .header__close {
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    right: 20px;
    top: 32px;
    z-index: 10;

    img {
      width: 16px;
      height: 16px;
      object-fit: contain;
    }
  }

  .alert-incident {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-radius: 6px;
    background: linear-gradient(90deg, #ff8500 0%, #fe4521 42.37%, #f72800 100%);
    padding: 15px;
    margin-top: 20px;
    margin-bottom: 20px;

    &--left {
      display: flex;
      align-items: center;

      .alert-incident__icon {
        display: flex;
        align-items: center;
        justify-content: center;

        img {
          width: 18px;
          height: 18px;
          object-fit: contain;
          margin-right: 10px;
          filter: invert(100%) sepia(0%) saturate(7483%) hue-rotate(131deg) brightness(100%)
            contrast(105%);
          filter: var(--icon-white);
        }
      }

      .alert-incident__text {
        color: #ffffff;
        font-size: 14px;
        font-weight: 600;
        letter-spacing: 0;
        line-height: 18px;
      }
    }
  }
}
